/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SupportRequestResponseDTOStatusEnum = {
    Pending: 'PENDING',
    Planned: 'PLANNED',
    Finished: 'FINISHED'
};
/**
 * Check if a given object implements the SupportRequestResponseDTO interface.
 */
export function instanceOfSupportRequestResponseDTO(value) {
    return true;
}
export function SupportRequestResponseDTOFromJSON(json) {
    return SupportRequestResponseDTOFromJSONTyped(json, false);
}
export function SupportRequestResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'adminResponse': json['adminResponse'] == null ? undefined : json['adminResponse'],
        'adminRespondedAt': json['adminRespondedAt'] == null ? undefined : (new Date(json['adminRespondedAt'])),
        'status': json['status'] == null ? undefined : json['status'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
    };
}
export function SupportRequestResponseDTOToJSON(json) {
    return SupportRequestResponseDTOToJSONTyped(json, false);
}
export function SupportRequestResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'description': value['description'],
        'adminResponse': value['adminResponse'],
        'adminRespondedAt': value['adminRespondedAt'] == null ? undefined : ((value['adminRespondedAt']).toISOString()),
        'status': value['status'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
    };
}
